<template>
    <div class="head-container">
        <div class="head-inner">
            <!--Logo-->
            <div class="wel-logo cursor" @click="jumpPageNotAuth('/hyedu/wel')">
                <img src="../assets/hy_logo.png" alt="">
                <div class="logo-text">
                    <div class="logo-name">恒岳教研</div>
                    <div class="logo-slogan">赋能教师专业化成长</div>
                </div>
            </div>
            <!--导航菜单-->
            <div class="nav-menu">
                <div v-for="m in menus" :key="m.index"
                     :class="['nav-item', activePath === m.index ? 'nav-active' : '']"
                     @click="handleNav(m)">{{ m.label }}</div>
                <el-popover placement="bottom" trigger="hover" :width="120"
                            :show-arrow="false"
                            popper-class="head-tool-popper">
                    <template #reference>
                        <div :class="['nav-item', activePath === 'aiAssistant' ? 'nav-active' : '']">AI+教研中心</div>
                    </template>
                    <div class="menu-item-list">
                        <div class="menu-item" @click="goSuperTeacher('/hyedu/aiInstructor','aiAssistant')">超级教研员</div>
                        <div class="menu-item" @click="goAiAide('/hyedu/aiaide','aiAssistant')">AI教学助手</div>
                    </div>
                </el-popover>
                <el-popover placement="bottom" trigger="hover" :width="120"
                            :show-arrow="false"
                            popper-class="head-tool-popper">
                    <template #reference>
                        <div :class="['nav-item', activePath === 'teachToolLink' ? 'nav-active' : '']">评估评价</div>
                    </template>
                    <div class="menu-item-list">
                        <div class="menu-item" @click="teachingToolLink('1')">课堂评估</div>
                        <div class="menu-item" @click="comingSoon">优质均衡</div>
                        <div class="menu-item" @click="teachingToolLink('2')">心理评价</div>
                    </div>
                </el-popover>
                <div :class="['nav-item', activePath === 'homeManagerCenter' ? 'nav-active' : '']"
                     @click="handleNav({ index: 'homeManagerCenter', args: ['/hyedu/managercenter', 'homeManagerCenter', '1'] })">
                    我的管理
                </div>
            </div>
            <!--右侧-->
            <div class="head-right">
                <!--已登录-->
                <template v-if="isLogin">
                    <button v-has-btn="'1,2,3,4,5'" class="admin-btn" @click="userAdmin">管理中心</button>
                    <el-badge :is-dot="messageBol" class="icon-badge">
                        <el-icon class="msg-icon cursor" :size="22"
                                 @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','3')"><Bell /></el-icon>
                    </el-badge>
                    <el-badge :is-dot="systemBol" class="icon-badge">
                        <el-icon class="msg-icon cursor" :size="22"
                                 @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','2')"><ChatDotSquare /></el-icon>
                    </el-badge>
                    <el-dropdown class="cursor">
                        <el-avatar :size="34" :src="userInfo.avatar + '?_=' + Date.now()" />
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item style="text-align: center;" @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','0')">个人中心</el-dropdown-item>
                                <el-dropdown-item style="text-align: center;" @click="userLogout">安全退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </template>
                <!--未登录-->
                <template v-else>
                    <span class="login-text cursor" @click="userToLogin">登录/注册</span>
                    <el-avatar class="avatar-default cursor" :size="34" icon="UserFilled" @click="userToLogin" />
                </template>
            </div>
        </div>
    </div>
</template>


<script>
import {timestampToTime} from "@/utils/date";
import {userMessages} from "@/api/admin/message";
import {gainXjUrl, gainIsAiAide} from "@/api/admin/aiHome";
export default {
    name: "homeHead",
    props: {
    },
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            messageBol: false,
            systemBol: false,
            activePath: "welHome",
            lastActivePath: "",
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            classroomUrl:'http://aipowered.k12.seegot.cn/#/login',//课堂分析
            careerUrl:'',//生涯规划
            /*导航菜单*/
            menus: [
                { index: 'welHome', label: '首页', notAuth: true, path: '/hyedu/wel' },
                { index: 'homeResourceCentre', label: '资源中心', args: ['/hyedu/resource', 'homeResourceCentre'], activeTab: 'school' },
                { index: 'homeEduResearch', label: '一体化教研', args: ['/hyedu/research', 'homeEduResearch', '2'] },
                { index: 'homeTeachResearch', label: '教科研', args: ['/hyedu/tearesearch', 'homeTeachResearch', '1'] },
                { index: 'teacherTrainCenter', label: '师资培训', args: ['/hyedu/train', 'teacherTrainCenter', '2'] },
                { index: 'teachStudioHome', label: '名师工作室', args: ['/hyedu/teastudio', 'teachStudioHome', '1'] },
                { index: 'rectorStudioHome', label: '名校长工作室', args: ['/hyedu/rectorstudio', 'rectorStudioHome', '1'] },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.isLogin){
            this.getMessage()
        }
        var currentDate = new Date();
        var currentHour = currentDate.getHours();
        if (0 <= currentHour && currentHour <= 6) {
            this.timeInfo = '凌晨'
        } else if (6 < currentHour && currentHour <= 12) {
            this.timeInfo = '上午'
        } else if (12 < currentHour && currentHour <= 18) {
            this.timeInfo = '下午'
        } else {
            this.timeInfo = '晚上'
        }
    },
    mounted() {},
    methods: {
        handleNav(m){
            this.lastActivePath = this.activePath
            this.activePath = m.index
            if (m.notAuth){
                this.jumpPageNotAuth(m.path)
            }else {
                this.jumpPageHome(m.args[0], m.args[1], m.args[2], m.activeTab)
            }
        },
        userToLogin(){
            this.$router.push("/login")
        },
        /*超级教研员：查询跳转链接并校验权限后跳转*/
        goSuperTeacher(path, activePath, activeItem){
            if (this.isLogin){
                gainXjUrl({userId: this.userInfo.userId}).then(res => {
                    if (res.data.code === 1){
                        this.lastActivePath = this.activePath
                        this.activePath = activePath
                        this.$store.commit("params/setJumpParams", {activePath: activePath, activeItem: activeItem});
                        this.$router.push({path: path});
                    }else {
                        this.$message({message: res.data.msg || '暂未开通，请联系管理员', type: 'info'});
                    }
                })
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }
        },
        /*AI教学助手：判断是否有权限后跳转*/
        goAiAide(path, activePath, activeItem){
            if (this.isLogin){
                gainIsAiAide({userId: this.userInfo.userId}).then(res => {
                    if (res.data.code === 1){
                        this.lastActivePath = this.activePath
                        this.activePath = activePath
                        this.$store.commit("params/setJumpParams", {activePath: activePath, activeItem: activeItem});
                        this.$router.push({path: path});
                    }else {
                        this.$message({message: res.data.msg || '暂未开通，请联系管理员', type: 'info'});
                    }
                })
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }
        },
        userToReg(){
            this.$router.push("/register")
        },
        userLogout() {
            this.$confirm("您正在退出恒岳教研，是否继续？", "退出系统", {
                confirmButtonText: "退出",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$storage.remove("token")
                this.$storage.remove("userInfo")
                this.$storage.remove("role");
                this.$storage.remove("isLogin");
                this.isLogin=false
                this.$router.push({ path: "/hyedu/wel" });
            })
        },
        jumpPage(activePath, activeSecondPath){
            if (this.isLogin){
                window.sessionStorage.setItem('activePath', activePath)
                window.sessionStorage.setItem('activeSecondPath', activeSecondPath)
                this.$router.push({ path: '/home' });
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        jumpPageNotAuth(path){
            this.$router.push(path);
        },
        jumpPageHome(path,activePath,activeItem,activeTab){
            if (this.isLogin){
                //参数传递
                const jumpParams = {activePath:activePath,activeItem: activeItem};
                if (activeTab){
                    jumpParams.activeTab = activeTab;
                }
                this.$store.commit("params/setJumpParams", jumpParams);
                this.$router.push({path: path,});
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        userAdmin(){
            this.$router.push({ path: '/hyedu/home' });
        },
        getMessage() {
            userMessages({ code: 1 }).then(res => {
                this.systemBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        this.systemBol = true;
                    }
                })
            });
            userMessages().then(res => {
                this.messageBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        if (e.code !== 1) {
                            this.messageBol = true;
                        }
                    }
                })
            });
        },
        /*优质均衡：敬请期待*/
        comingSoon(){
            this.$message({message: '敬请期待', type: 'info'});
        },
        teachingToolLink(type){
            if (this.isLogin){
                if (type==='1'){
                    //课堂评估：跳转站内课堂评估页
                    this.$router.push({ path: '/hyedu/classevaluate' })
                    return
                }
                if (type==='2'){
                    //心理评价：跳转站内心理评价页
                    this.$router.push({ path: '/hyedu/mentality' })
                    return
                }
                let toolLink = this.classroomUrl;
                if (type==='3'){
                    toolLink = this.careerUrl
                }
                window.open(toolLink, '_blank')
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        }
    }

};
</script>

<style scoped lang="scss">
.head-container{
    height: 80px;
    width: 100%;
    background: transparent;
    position: fixed;
    top: 0;
    z-index: 999;
    background-color: #bce3fe;
}
.head-inner{
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 40px;
    box-sizing: border-box;
}
/*Logo*/
.wel-logo{
    display: flex;
    align-items: center;
    flex-shrink: 0;

    img {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .logo-name {
        font-size: 20px;
        font-weight: 700;
        color: #0d55a4;
        line-height: 1.2;
        letter-spacing: 1px;
        text-align: center;
    }

    .logo-slogan {
        font-size: 12px;
        color: #f29c2b;
        margin-top: 2px;
        font-weight: 600;
    }
}
/*导航菜单*/
.nav-menu{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
}
.nav-item{
    position: relative;
    font-size: 16px;
    color: #1f5aa8;
    cursor: pointer;
    padding: 6px 2px;
    white-space: nowrap;
    
}
.nav-item:hover{
    color: #f29c2b;
}
.nav-active{
    color: #f29c2b;
    font-weight: 700;
}
.nav-active::after{
    content: '';
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    width: 26px;
    height: 3px;
    border-radius: 2px;
    background: #f29c2b;
}
/*右侧*/
.head-right{
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 16px;
}
.admin-btn{
    height: 32px;
    padding: 0 18px;
    border: 1px solid #1f5aa8;
    border-radius: 16px;
    background: transparent;
    color: #1f5aa8;
    font-size: 14px;
    cursor: pointer;
}
.admin-btn:hover{
    background: #1f5aa8;
    color: #ffffff;
}
.msg-icon{
    color: #1f5aa8;
    vertical-align: middle;
}
.login-text{
    font-size: 15px;
    color: #1f5aa8;
}
.avatar-default{
    background: #0d55a4;
}
::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    opacity: 0.9 !important;
    background: #0d55a4;
}
::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 0;
    background: #c1c6cd;
}
</style>

<!--评估评价弹层样式（teleport 到 body，需非 scoped）-->
<style lang="scss">
.head-tool-popper{
    padding: 6px 0 !important;
    min-width: 110px !important;

    .menu-item-list{
        height: auto;
    }

    .menu-item{
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: #1f5aa8;
        cursor: pointer;
    }

    .menu-item:hover{
        color: #f29c2b;
        font-weight: 700;
    }
}
</style>
